import { Component, OnInit } from '@angular/core';
import { REDIRECTION_INFO, SESSION_STORAGE_KEYS } from 'src/app/shared/types/types';
import { SharedService } from 'src/app/shared/services/other/shared.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/shared/services/other/toaster.service';
import { SamhitaOndcWoCService } from 'src/app/shared/services/api/samhita-ondc-wo-c.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  constructor(
    private router: Router,
    private activateRouter: ActivatedRoute,
    private sharedService: SharedService,
    private toastService: ToastService,
    private samhitaOndcWoCService: SamhitaOndcWoCService
  ) { }

  ngOnInit(): void {
    this.validateToken();
  }

  private validateToken(): void {
    const { token  } = this.activateRouter.snapshot.params;
    if (!token) {
      this.redirectToNotFound();
      return;
    }
    this.storeAndValidateTokens({ token  });
  }

  private async storeAndValidateTokens(tokenAndRedirect: { token:string }): Promise<void> {
    try {
      this.sharedService.setDataToSessionStorage({ data: {access: tokenAndRedirect.token}, key: SESSION_STORAGE_KEYS.SESSION_TOKEN });
      const userData = await this.getTheUserDetails()
      if (userData) {
        this.sharedService.setDataToSessionStorage({ data: userData, key: SESSION_STORAGE_KEYS.USER_INFO });
        this.handleSuccessfulValidation(userData);
      } else {
        this.resetUserSession();
      }
    } catch (error) {
      this.resetUserSession();
    }
  }

  async getTheUserDetails() {
    try {
      return await this.samhitaOndcWoCService.getUserDetailsNew()
    } catch (error) {
      return null
    }
  }

  private handleSuccessfulValidation(userData: any): void {
    this.sharedService.userSessionCreated.next(true);
    this.toastService.presentToast('User logged in successfully!', 'success', 'bottom');
    const redirectionData = this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.REDIRECTION_DATA) as REDIRECTION_INFO
    if(redirectionData?.PARAM_URL && redirectionData?.QUERY_PARAMS){
      const pathSegments = redirectionData.PARAM_URL.split('/');
      this.router.navigate(pathSegments, { queryParams: redirectionData.QUERY_PARAMS });
    }else if(redirectionData?.PARAM_URL){
      this.router.navigateByUrl(redirectionData.PARAM_URL);
    }else{
      this.router.navigate(['/home']);
    }
    this.sharedService.removeDataToSessionStorage(SESSION_STORAGE_KEYS.REDIRECTION_DATA)
  }

  private resetUserSession(): void {
    this.sharedService.clearSessionStorage();
    this.redirectToNotFound();
  }

  private redirectToNotFound(): void {
    this.router.navigate(['/not-found']);
  }

}
